import { smpteTimecode, formatSmpte } from '../frame/frameMath';
import type { FrameRate } from '../frame/frameRates';

export interface ClockView {
  update(nowMs: number, rate: FrameRate): void;
}

export function createClockView(host: HTMLElement): ClockView {
  host.classList.add('clock');
  host.innerHTML = `
    <div class="clock__utc" data-role="utc">--:--:--.---</div>
    <div class="clock__tc" data-role="tc">--:--:--:--</div>
    <div class="clock__label" data-role="label">UTC</div>
  `;
  const utc = host.querySelector<HTMLElement>('[data-role="utc"]')!;
  const tc = host.querySelector<HTMLElement>('[data-role="tc"]')!;
  const label = host.querySelector<HTMLElement>('[data-role="label"]')!;

  const pad = (n: number, w = 2) => Math.floor(n).toString().padStart(w, '0');

  return {
    update(nowMs, rate) {
      const d = new Date(nowMs);
      const utcStr = `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}.${pad(d.getUTCMilliseconds(), 3)}`;
      if (utc.textContent !== utcStr) utc.textContent = utcStr;

      const tcStr = formatSmpte(smpteTimecode(nowMs, rate), rate.fps);
      if (tc.textContent !== tcStr) tc.textContent = tcStr;

      const labelStr = `UTC · ${rate.label} fps${rate.isDropFrame ? ' DF' : ''}`;
      if (label.textContent !== labelStr) label.textContent = labelStr;
    },
  };
}
